// import React from 'react'
// import { Link } from 'react-router-dom'
// import ImageWithBasePath from '../imageWithBasePath'
// import { all_routes } from '../../../feature-module/router/all_routes'

// const Footer = () => {

//   return (
// <>
//   {/* Footer */}
//   <footer className="footer">
//     <div className="footer-bg">
//       <ImageWithBasePath
//         src="assets/img/bg/footer-bg-01.png"
//         className="footer-bg-1"
//         alt=""
//       />
//       <ImageWithBasePath
//         src="assets/img/bg/footer-bg-02.png"
//         className="footer-bg-2"
//         alt=""
//       />
//     </div>
//     <div className="footer-top">
//       <div className="container">
//         <div className="row row-gap-4">
//           <div className="col-lg-4">
//             <div className="footer-about">
//               <div className="footer-logo">
//                 <ImageWithBasePath src="assets/img/logo-white.png" alt="" />
//               </div>
//               <p>
//                 Platform designed to help organizations, educators, and learners
//                 manage, deliver, and track learning and training activities.
//               </p>
//               <div className="d-flex align-items-center">
//                 <Link to="#" className="me-2">
//                   <ImageWithBasePath src="assets/img/icon/appstore.svg" alt="" />
//                 </Link>
//                 <Link to="#">
//                   <ImageWithBasePath src="assets/img/icon/googleplay.svg" alt="" />
//                 </Link>
//               </div>
//             </div>
//           </div>
//           <div className="col-lg-8">
//             <div className="row row-gap-4">
//               <div className="col-lg-3">
//                 <div className="footer-widget footer-menu">
//                   <h5 className="footer-title">For Instructor</h5>
//                   <ul>
//                     <li>
//                       <Link to={all_routes.courseGrid}>Search Mentors</Link>
//                     </li>
//                     <li>
//                       <Link to={all_routes.login}>Login</Link>
//                     </li>
//                     <li>
//                       <Link to={all_routes.register}>Register</Link>
//                     </li>
//                     <li>
//                       <Link to={all_routes.courseList}>Booking</Link>
//                     </li>
//                     <li>
//                       <Link to={all_routes.studentDashboard}>Students Dashboard</Link>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//               <div className="col-lg-3">
//                 <div className="footer-widget footer-menu">
//                   <h5 className="footer-title">For Student</h5>
//                   <ul>
//                     <li>
//                       <Link to="#">Appointments</Link>
//                     </li>
//                     <li>
//                       <Link to={all_routes.instructorMessage}>Chat</Link>
//                     </li>
//                     <li>
//                       <Link to={all_routes.login}>Login</Link>
//                     </li>
//                     <li>
//                       <Link to={all_routes.register}>Register</Link>
//                     </li>
//                     <li>
//                       <Link to={all_routes.instructorDashboard}>
//                         Instructor Dashboard
//                       </Link>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//               <div className="col-lg-6">
//                 <div className="footer-widget footer-contact">
//                   <h5 className="footer-title">Newsletter</h5>
//                   <div className="subscribe-input">
//                     <form action="#">
//                       <input
//                         type="email"
//                         className="form-control"
//                         placeholder="Enter your Email Address"
//                       />
//                       <button
//                         type="submit"
//                         className="btn btn-primary btn-sm inline-flex align-items-center"
//                       >
//                         <i className="isax isax-send-2 me-1" />
//                         Subscribe
//                       </button>
//                     </form>
//                   </div>
//                   <div className="footer-contact-info">
//                     <div className="footer-address d-flex align-items-center">
//                       <ImageWithBasePath
//                         src="assets/img/icon/icon-20.svg"
//                         alt="Img"
//                         className="img-fluid me-2"
//                       />
//                       <p>
//                         {" "}
//                         3556 Beech Street, San Francisco,
//                         <br /> California, CA 94108{" "}
//                       </p>
//                     </div>
//                     <div className="footer-address d-flex align-items-center">
//                       <ImageWithBasePath
//                         src="assets/img/icon/icon-19.svg"
//                         alt="Img"
//                         className="img-fluid me-2"
//                       />
//                       <p>InstaAdmissions@example.com</p>
//                     </div>
//                     <div className="footer-address d-flex align-items-center">
//                       <ImageWithBasePath
//                         src="assets/img/icon/icon-21.svg"
//                         alt="Img"
//                         className="img-fluid me-2"
//                       />
//                       <p>+19 123-456-7890</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//     <div className="footer-bottom">
//       <div className="container">
//         <div className="row row-gap-2">
//           <div className="col-md-6">
//             <div className="text-center text-md-start">
//               <p className="text-white">
//                 Copyright © 2025 UniversityRack. All rights reserved.
//               </p>
//             </div>
//           </div>
//           <div className="col-md-6">
//             <div>
//               <ul className="d-flex align-items-center justify-content-center justify-content-md-end footer-link">
//                 <li>
//                   <Link to={all_routes.termsConditions}>Terms &amp; Conditions</Link>
//                 </li>
//                 <li>
//                   <Link to={all_routes.privacyPolicy}>Privacy Policy</Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </footer>
//   {/* /Footer */}
// </>


//   )
// }

// export default Footer

import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../../feature-module/router/all_routes'
import apiInstance from '../../../utility/apiInstance'

const Footer = () => {
    const [email, setEmail] = useState('');
    const [subscribeMsg, setSubscribeMsg] = useState('');

    const handleSubscribe = async (e: React.FormEvent) => {
        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setSubscribeMsg('Please enter a valid email address');
            return;
        }
        try {
            await apiInstance.post('/api/newsletter-subscribers', { email });
            setSubscribeMsg('Thanks for subscribing!');
            setEmail('');
        } catch (err: any) {
            const errorMsg =
                err?.response?.data?.errors?.[0]?.message ||
                err?.message ||
                'Failed to subscribe. Please try again.';
            setSubscribeMsg(errorMsg);
        }
    };

    return (
        <footer className="footer footer-six">
            {/* Footer Top */}
            <div className="footer-top-five">
                <div className="container">
                    <div className="row row-gap-3">
                        <div className="col-lg-2 col-md-3 col-sm-12">
                            {/* Footer Widget */}
                            <div className="footer-menu footer-menu-five">
                                <h5 className="footer-title footer-title-five">For Student</h5>
                                <ul>
                                    <li>
                                        <Link to={all_routes.studentProfile}>Profile</Link>
                                    </li>
                                    <li>
                                        <Link to={all_routes.login}>Login</Link>
                                    </li>
                                    <li>
                                        <Link to={all_routes.register}>Register</Link>
                                    </li>
                                    <li>
                                        <Link to={all_routes.studentHome}>Student</Link>
                                    </li>
                                    <li>
                                        <Link to={all_routes.studentDashboard}> Dashboard</Link>
                                    </li>
                                </ul>
                            </div>
                            {/* /Footer Widget */}
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-12">
                            {/* Footer Widget */}
                            <div className="footer-menu footer-menu-five">
                                <h5 className="footer-title footer-title-five">
                                    <i className="fa-sharp fa-solid fa-dash" />
                                    For Institution
                                </h5>
                                <ul>
                                    {/* <li>
                                        <Link to={all_routes.instructorProfile}>Profile</Link>
                                    </li> */}
                                    <li>
                                        <Link to={all_routes.login}>Login</Link>
                                    </li>
                                    <li>
                                        <Link to={all_routes.register}>Register</Link>
                                    </li>
                                    <li>
                                        <Link to={all_routes.institutionHome}>Institution</Link>
                                    </li>
                                    {/* <li>
                                        <Link to={all_routes.instructorDashboard}> Dashboard</Link>
                                    </li> */}
                                </ul>
                            </div>
                            {/* /Footer Widget */}
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-12">
                            {/* Footer Widget */}
                            <div className="footer-menu footer-menu-five">
                                <h5 className="footer-title footer-title-five">
                                    <i className="fa-sharp fa-solid fa-dash" />
                                    For Recruiter
                                </h5>
                                <ul>
                                    {/* <li>
                                        <Link to={all_routes.instructorProfile}>Profile</Link>
                                    </li> */}
                                    <li>
                                        <Link to={all_routes.login}>Login</Link>
                                    </li>
                                    <li>
                                        <Link to={all_routes.register}>Register</Link>
                                    </li>
                                    <li>
                                        <Link to={all_routes.recruiterHome}>Recruiter</Link>
                                    </li>
                                    {/* <li>
                                        <Link to={all_routes.instructorDashboard}> Dashboard</Link>
                                    </li> */}
                                </ul>
                            </div>
                            {/* /Footer Widget */}
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            {/* Footer Widget */}
                            <div className="footer-contact footer-menu-five">
                                <h5 className="footer-title footer-title-five">Get in touch</h5>
                                <div className="footer-contact-info">
                                    <div className="footer-address">
                                        <h6>Phone Number</h6>
                                        <p>310-437-2766</p>
                                    </div>
                                    <div className="footer-address">
                                        <h6>Mail Address</h6>
                                        <p>contact@example.com</p>
                                    </div>
                                    <div className="footer-address">
                                        <h6>Address</h6>
                                        <p>706 Campfire Ave. Meriden, CT </p>
                                    </div>
                                </div>
                            </div>
                            {/* /Footer Widget */}
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="footer-menu">
                                <h5 className="footer-title footer-title-five mb-1">
                                    Subscription
                                </h5>
                                <p className="fs-14 text-light">
                                    Sign up to get updates &amp; news.
                                </p>
                                {/* Footer Widget */}
                                <div className="footer-widget-five mb-3">
                                    <div className="box-form-newsletter">
                                        <form className="form-newsletter" onSubmit={handleSubscribe}>
                                            <input
                                                className="input-newsletter"
                                                type="email"
                                                placeholder="Email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                            <button type="submit" className="btn btn-secondary font-heading icon-send-letter">
                                                Subscribe
                                            </button>
                                        </form>
                                    </div>
                                    {subscribeMsg && <p className="fs-14 text-light mt-2 mb-0">{subscribeMsg}</p>}
                                </div>
                                {/* <div className="d-flex align-items-center gap-3 flex-wrap">
                                    <Link to="#">
                                        <ImageWithBasePath src="./assets/img/icon/app-store.svg" alt="img" />
                                    </Link>
                                    <Link to="#">
                                        <ImageWithBasePath src="./assets/img/icon/google-play.svg" alt="img" />
                                    </Link>
                                </div> */}
                                {/* /Footer Widget */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Footer Top */}
            {/* Footer Bottom */}
            <div className="footer-bottom footer-bottom-six">
                <div className="container">
                    {/* Copyright */}
                    <div className="copyright-five">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <div className="copyright-text">
                                    <p>© {new Date().getFullYear()} InstaAdmissions. All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Copyright */}
                </div>
            </div>
            {/* /Footer Bottom */}
        </footer>

    )
}

export default Footer